export default __webpack_public_path__ + "static/media/dana-logo.17842a6a.svg";